import {WSOCIAL_APPVIEW} from '#/lib/constants'
import {WsocAgent} from '#/state/session/wsocAgent.ts'

// Add NSID strings here to route unauthenticated requests through WSOCIAL_APPVIEW.
// Callers check via shouldRouteToPublicAppview(nsid) — no other changes needed.
export const WSOCIAL_PUBLIC_NSIDS = new Set<string>([
  'app.bsky.ageassurance.getConfig',
  'app.bsky.labeler.getServices',
  'app.bsky.graph.getSuggestedFollowsByActor',
  'app.bsky.actor.getSuggestions',
  'app.bsky.unspecced.getConfig',
  'app.bsky.unspecced.getPostThreadV2',
  'app.bsky.actor.getProfile',
  //'app.bsky.actor.searchActorsTypeahead',
  //'app.bsky.feed.searchPosts',
])

let _agent: WsocAgent | null = null

export function getWsocialPublicAgent(): WsocAgent {
  if (_agent === null) {
    _agent = new WsocAgent({service: WSOCIAL_APPVIEW})
  }
  return _agent
}

export function shouldRouteToPublicAppview(nsids: string[]): boolean {
  return nsids.some(nsid => WSOCIAL_PUBLIC_NSIDS.has(nsid))
}
